<!--  -->
<template>
  <div class="information">
    <div class="single">
      <img src="@/assets/VisionMission.png" alt="" />
      <div class="text">愿景和使命</div>
      <div>“构建全民共享的智能化服务平台”</div>
      <div>为用户提供全生命周期服务，助力企业高效运营，用户技能</div>
      <div>提升，共同推动行业进步与繁荣。</div>
    </div>

    <div class="single">
      <img src="@/assets/value.png" alt="" />
      <div class="text">价值观</div>
      <div>安全第一、合法合规、精准高效、用户至上、创新驱动</div>
      <div>诚信守信、团队协作、共赢发展</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.information {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #141414;
  line-height: 28px;
  display: flex;
  justify-content: space-between;
  padding: 90px 360px;
  background: url("@/assets/companybg3.png") no-repeat;
  background-size: 100% 100%;
  img {
    width: 52px;
    height: 52px;
    margin-bottom: 12px;
  }
  .text {
    font-weight: 500;
    font-size: 18px;
    color: #141414;
    margin-bottom: 20px;
  }
  .single {
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    padding: 62px 102px;
  }
}
@media (max-width: 750px) {
  .information {
    padding: 90px 240px;
  }
}
</style>
